module.exports = __webpack_public_path__ + "img/QR.daf99aca.png";